module.exports = __webpack_public_path__ + "img/2023_Nature.3f4c9c4d.png";